/**
 * Get url query param value
 * @param {string} key
 * @returns {string}
 */
function getQueryParam(key) {
	const search = window.location.search;
	const urlParams = new URLSearchParams(search);

	const params = new Proxy(urlParams, {
		get: (searchParams, prop) => {
			return searchParams.get(`${prop}`)
		},
	});
	return params[key];
}
